<div class="relative w-full h-full flex flex-col p-4">
  @if (sheets.isLoading()) {
    <div class="absolute inset-0 flex items-center justify-center bg-white z-10">
      <app-loading-indicator>Loading file...</app-loading-indicator>
    </div>
  } @else if (sheets.error()) {
    <app-preview-error [error]="sheets.error()"/>
  } @else {
    @if (sheets.value().length > 1) {
      <div class="flex flex-wrap gap-0.5 px-2 pt-1.5 bg-gray-50 border-b border-gray-200">
        @for (sheet of sheets.value(); track sheet.name; let idx = $index) {
          <app-button2
            [appearance]="idx === activeSheetIndex() ? 'primary-ghost' : 'secondary-ghost'"
            size="s"
            (click)="selectSheet(idx)"
          >
            {{ sheet.name }}
          </app-button2>
        }
      </div>
    }
    <div class="file-preview-spreadsheet flex-1 overflow-auto" [innerHTML]="activeSheet()?.html"></div>
  }
</div>
